(function () {
function injectSection() {
    const container = document.querySelector('#no-results-bm');
    if (container && !container.dataset.loaded) {
    fetch('/?sections=bloomreach-not-found')
        .then(res => res.json())
        .then(json => {
        if (json['bloomreach-not-found']) {
            container.innerHTML = json['bloomreach-not-found'];
            container.dataset.loaded = "1";
        }
        })
        .catch(err => console.error('Erreur injection bloomreach-not-found:', err));
    }
}

const observer = new MutationObserver(() => injectSection());
observer.observe(document.body, { childList: true, subtree: true });

injectSection();
})();